import parse from "html-react-parser";
import { Card, Container } from "react-bootstrap";

import PageHeader from "../../components/PageHeader";
import { useAppSelector } from "../../redux/Store";
import { authDataSelector } from "../../redux/slice/AuthDataSlice";

const TermsAndCondition = () => {
  const { globalSettingsData } = useAppSelector(authDataSelector);
  return (
    <>
      <Container className="w-800 mt-5 pb-5">
        <PageHeader title="Terms and Condition" />
        <Card>
          <Card.Body>
            {globalSettingsData?.TERMS_AND_CONDITIONS?.value &&
              parse(globalSettingsData.TERMS_AND_CONDITIONS.value)}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default TermsAndCondition;
